import http from '@/http-common'

const omieImportClients = async () => {
  return await http
    .post('/omie/import-clientes')
    .then(r => r.data)
    .catch(error => {
      throw error.response?.data || error.response || error
    })
}
const omieImportClientsStatus = async () => {
  return await http
    .get('/omie/import-clientes/status')
    .then(r => r.data)
    .catch(error => {
      throw error.response?.data || error.response || error
    })
}

const omieImportBanks = async () => {
  return await http
    .post('/omie/import-bancos')
    .then(r => r.data)
    .catch(error => {
      throw error.response?.data || error.response || error
    })
}

const omieImportBanksStatus = async () => {
  return await http
    .get('/omie/import-bancos/status')
    .then(r => r.data)
    .catch(error => {
      throw error.response?.data || error.response || error
    })
}

export default {
  omie: {
    importClients: omieImportClients,
    importClientsStatus: omieImportClientsStatus,
    importBanks: omieImportBanks,
    importBanksStatus: omieImportBanksStatus,
  },
};
